import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useContext, useEffect, forwardRef } from "react";
import { Combobox as FluentComboBox, makeStyles, tokens, useComboboxFilter, useId, Option } from "@fluentui/react-components";
import { ToolContext } from "../hoc/fluentToolWrapper";
import { CustomTokens } from "./utils";
const useStyles = makeStyles({
    root: {
        display: "grid",
        gridTemplateRows: "repeat(1fr)",
        justifyItems: "start",
        gap: "2px",
        maxWidth: "400px",
    },
    comboBox: {
        width: CustomTokens.valueWidth,
        minWidth: CustomTokens.valueWidth,
        boxSizing: "border-box",
    },
    input: {
        minWidth: 0,
    },
    listbox: {
        width: "fit-content",
        minWidth: "fit-content",
        maxWidth: "350px",
    },
    compactOption: {
        fontSize: tokens.fontSizeBase200,
        lineHeight: tokens.lineHeightBase200,
        padding: `${tokens.spacingVerticalXXS} ${tokens.spacingHorizontalS}`,
    },
});
/**
 * Wrapper around a Fluent ComboBox that allows for filtering options.
 * @param props
 * @returns
 */
export const ComboBox = forwardRef((props, ref) => {
    ComboBox.displayName = "ComboBox";
    const comboId = useId();
    const styles = useStyles();
    const { size } = useContext(ToolContext);
    // Find the label for the current value
    const getLabel = (value) => props.options.find((opt) => opt.value === value)?.label ?? "";
    const [query, setQuery] = useState(getLabel(props.value ?? ""));
    useEffect(() => {
        setQuery(getLabel(props.value ?? ""));
    }, [props.value, props.options]);
    // Convert to Fluent's { children, value } format
    const normalizedOptions = props.options.map((opt) => ({ children: opt.label, value: opt.value }));
    const children = useComboboxFilter(query, normalizedOptions, {
        noOptionsMessage: "No items match your search.",
        optionToReactKey: (option) => option.value,
        optionToText: (option) => option.children,
        renderOption: (option) => (_jsx(Option, { value: option.value, text: option.children, className: size === "small" ? styles.compactOption : undefined, children: option.children }, option.value)),
    });
    const onOptionSelect = (_e, data) => {
        setQuery(data.optionText ?? "");
        data.optionValue && props.onChange(data.optionValue);
    };
    return (_jsxs("div", { className: styles.root, children: [_jsx("label", { id: comboId, children: props.label }), _jsx(FluentComboBox, { ref: ref, defaultOpen: props.defaultOpen, disabled: props.disabled, size: size, root: { className: styles.comboBox }, input: { className: styles.input }, listbox: { className: styles.listbox }, onOptionSelect: onOptionSelect, "aria-label": props.ariaLabel, "aria-labelledby": props.ariaLabel ? undefined : comboId, placeholder: "Search..", onChange: (ev) => setQuery(ev.target.value), value: query, children: children })] }));
});
//# sourceMappingURL=comboBox.js.map